import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  NgxUiLoaderModule } from 'ngx-ui-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FmsAgencyComponent } from './fms-agency.component';
import { FmsAgencyRoutingModule } from './fms-agency-routing.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { CommonHttpService } from 'src/app/common.service';
@NgModule({
  declarations: [FmsAgencyComponent],
  imports: [
    CommonModule,
       FormsModule,
       ReactiveFormsModule,
       NgbModule,
       MultiselectDropdownModule,
       NgxPaginationModule,
       PipesModule,
       GridModule,
       NgSelectModule,
       NgxUiLoaderModule,
       MaskedTextBoxModule,
       FmsAgencyRoutingModule
  ],
  exports:[FmsAgencyComponent],
    providers: [CommonHttpService,ColumnChooserService,PageService,SortService,FilterService,ResizeService ],
})
export class FmsAgencyModule { }